<form class="needs-validation" #f="ngForm" novalidate>
  <fieldset>
    <!-- Modal Header -->
    <div class="modal-header">
      <p class="modal-title"><strong>Pending Action Report</strong></p>
      <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <div class="col-12">
        <div class="row">
          <div class="col-md-6 mb-3 form-group">
            <label for="documentTypeId">Office location country</label>
            <select name="countryId" class="form-select form-select-sm" [(ngModel)]="officelocationCountryId"
              #countryIdRef="ngModel" [ngClass]="{ 'is-invalid': countryIdRef.invalid && countryIdRef.dirty }" required>
              <option [ngValue]="null">Select</option>
              <option *ngFor="let type of countries" [ngValue]="type.id">
                {{type.displayText }}
              </option>
            </select>
            <div *ngIf="countryIdRef.invalid" class="invalid-feedback">
              <div *ngIf="countryIdRef.errors.required">Office location country is required</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center mt-3">
        <button class="btn btn-outline-primary me-2" (click)="modal.dismiss()" type="button">
          Cancel
        </button>
        <!-- <button class="btn btn-outline-primary me-2" (click)="downloadPendingActionReport()" [disabled]="f.invalid">
          <span *ngIf="!disableDownload">Report</span>
          <span *ngIf="disableDownload" class="timelinespinner"></span>
        </button> -->
      </div>
    </div>
  </fieldset>
</form>